import { cx } from '@/lib/cx';
import s from './TelemetryTrace.module.css';

// Deterministic tick heights: the brand's "telemetry trace" divider (handover.html) — reads
// as sensor data. Fixed so it renders identically on every visit.
const TICKS = [5, 9, 4, 11, 7, 13, 6, 10, 4, 8, 12, 5, 9, 14, 7, 4, 10, 6, 12, 8, 5, 11, 7, 13, 4, 9, 6, 10, 12, 5, 8, 11, 4, 7, 13, 6, 9, 5, 10, 8];

export function TelemetryTrace({ className, ticks = 40 }: { className?: string; ticks?: number }) {
  const n = Math.min(ticks, TICKS.length);
  return (
    <svg className={cx(s.trace, className)} viewBox={`0 0 ${n * 4} 14`} preserveAspectRatio="none" aria-hidden>
      {TICKS.slice(0, n).map((h, i) => (
        <line key={i} x1={i * 4 + 1} x2={i * 4 + 1} y1={14} y2={14 - h} />
      ))}
    </svg>
  );
}
